export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "pl": {
        "Map": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mapa"])},
        "Packets": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pakiety"])},
        "WX": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["WX"])},
        "Altitude": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wysokość"])}
      }
    }
  })
}
